import { capitalize } from "@mui/material";
import { NUMBER_TO_MONTH } from "aint-utils";

export const generateMonthLabels = (
  startMonth: number,
  startYear: string,
  numMonths: number
): string[] => {
  const labels: string[] = [];
  let currentMonth = startMonth;
  let currentYear = parseInt(startYear, 10);

  for (let i = 0; i < numMonths; i++) {
    labels.push(`${capitalize(NUMBER_TO_MONTH[currentMonth])} ${currentYear}`);
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
  }

  return labels;
};

/**
 * Converts the monthly data to yearly. Since the impact values are cumulative, the december value represents the yearly value.
 * Only if a year is not fully included in the dataset, we use the last value.
 */
export const convertToYearlyData = (
  data: (number | null)[],
  startMonthIndex: number
): (number | null)[] => {
  if (!data || data.length === 0) return [];

  let currentMonth = startMonthIndex;
  const yearlyData: (number | null)[] = [];

  data.forEach((value, index) => {
    // use december value for year, or the last index, in case the last year is not fully in the dataset.
    if (currentMonth === 11 || index === data.length - 1) {
      yearlyData.push(value);
    }

    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
    }
  });

  return yearlyData;
};
